<template>
  <div class="Reader centre">
    <div class="img-box">
      <img src="../../assets/img/reader/03.png" alt="" class="img1"/>
      <img src="../../assets/img/reader/03.png" alt="" class="img2"/>
      <img src="../../assets/img/reader/03.png" alt="" class="img3"/>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="用户管理" name="user">
        <Basics v-if="getUserBool"/>
      </el-tab-pane>
      <el-tab-pane label="个人收藏" name="collect">
        <MyCollect v-if="getUserBool"/>
      </el-tab-pane>
      <el-tab-pane label="阅读历史" name="read">
        <Read v-if="getUserBool"/>
      </el-tab-pane>
    </el-tabs>
    <div v-show="!getUserBool">
      <el-empty description="请先登录"></el-empty>
    </div>
  </div>
</template>

<script>
  import Basics from './Basics.vue'
  import MyCollect from './mycollect/MyCollect.vue'
  import Read from './read/Read.vue'

  export default {
    data() {
      return {
        activeName: "user",
      };
    },
    computed: {
      getUserBool() {
        return this.$store.state.userInfo.userId && sessionStorage.getItem("portal_user_info");
      },
    },
    methods: {},
    components: {
      Basics,
      MyCollect,
      Read
    }
  };
</script>

<style lang="less" scoped>

  .Reader {
    min-height: 600px;
    background-color: #fff;
    position: relative;

    .img-box {
      img {
        position: absolute;
        top: 82px;
        z-index: 4;
      }

      .img1 {
        left: 330px;
      }

      .img2 {
        left: 578px;
      }

      .img3 {
        left: 826px;
      }
    }

    /deep/ .el-tabs__item.is-active {
      border-radius: 8px;
      background-color: #654719;
      color: #fff;
    }

    /deep/ .el-tabs__nav {
      display: flex;
      padding: 76px 348px 36px;
    }

    /deep/ .el-tabs__item {
      width: 208px;
      height: 54px;
      border: solid 1px #654719;
      color: #242424;
      font-size: 20px;
      line-height: 54px;
      margin-right: 40px;
      padding: 0;
      text-align: center;
    }

    /deep/ .el-tabs__item.is-top:last-child {
      margin-right: 0;
    }

    /deep/ .el-tabs__nav-wrap::after {
      background-color: #fff;
    }

    /deep/ .el-tabs__active-bar {
      background-color: #fff;
    }

    /deep/ .el-tabs__nav-nex,
    .el-tabs__nav-prev {
      display: none;
    }

    /deep/ .el-tabs__content {
      padding: 0 96px;
    }

    /deep/ .el-empty {
      min-height: 600px;
    }
  }
</style>
